import Transfer from './view/transfer';

export default Transfer;
